import React, { Component } from 'react'
import s from './style.scss'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

class Modal extends Component {

	constructor(props) {
		super(props)

		this.state = {
			index: 0
		}
	}

	render() {

		const { tabs } = this.props
		const { index } = this.state

		return <div className={s.container}>

			<div className={s.tabs}>
				{tabs.map(({ name }, i) => {
					return <div className={classnames(s.tab, i === index && s.active)} key={i} onClick={() => this.setState({ index: i })}>{name}</div>
				})}
			</div>

			<div className={s.content}>
				{tabs[index].content}
			</div>

		</div>

	}
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/Tabs/index.js